/**
 * MT Versatii Slider
 * Responsive carousel with autoplay, touch support, and progress indicator
 */

document.addEventListener('DOMContentLoaded', function() {
  // Initialize all sliders on the page
  const sliders = document.querySelectorAll('.mt-versatii-container');
  
  sliders.forEach(container => {
    const slider = container.querySelector('.mt-versatii-slider');
    if (!slider) return;
    
    const slides = slider.querySelectorAll('.mt-versatii-slide');
    if (slides.length === 0) return;
    
    // Configuration
    const config = {
      currentIndex: 0,
      totalSlides: slides.length,
      isAutoplay: slider.dataset.autoplay === 'true',
      autoplayDelay: parseInt(slider.dataset.autoplayDelay) || 5000,
      autoplayTimer: null,
      isAnimating: false,
      isPaused: false,
      isMobile: window.innerWidth <= 768,
      slidesPerView: window.innerWidth <= 768 ? 1 : 3,
      touchStartX: 0,
      touchEndX: 0,
      minSwipeDistance: 50
    };
    
    // Get elements
    const prevBtn = container.querySelector('.mt-versatii-nav-prev');
    const nextBtn = container.querySelector('.mt-versatii-nav-next');
    const progressBar = container.querySelector('.mt-versatii-progress-bar');
    const currentSpan = container.querySelector('.mt-versatii-current');
    
    // Initialize
    init();
    
    function init() {
      updateProgress();
      
      // Bind events
      if (prevBtn) {
        prevBtn.addEventListener('click', handlePrev);
      }
      
      if (nextBtn) {
        nextBtn.addEventListener('click', handleNext);
      }
      
      // Touch events for mobile swipe
      slider.addEventListener('touchstart', handleTouchStart, { passive: true });
      slider.addEventListener('touchmove', handleTouchMove, { passive: true });
      slider.addEventListener('touchend', handleTouchEnd);
      
      // Mouse drag for desktop
      let isDragging = false;
      let startX = 0;
      let scrollLeft = 0;
      
      slider.addEventListener('mousedown', (e) => {
        isDragging = true;
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
        slider.style.cursor = 'grabbing';
        config.isPaused = true;
      });
      
      slider.addEventListener('mouseleave', () => {
        isDragging = false;
        slider.style.cursor = 'grab';
      });
      
      slider.addEventListener('mouseup', () => {
        isDragging = false;
        slider.style.cursor = 'grab';
        
        // Snap to nearest slide after drag
        setTimeout(() => {
          snapToNearestSlide();
          config.isPaused = false;
        }, 100);
      });
      
      slider.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 2;
        slider.scrollLeft = scrollLeft - walk;
      });
      
      // Scroll event to update progress
      let scrollTimeout;
      slider.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          updateCurrentIndexFromScroll();
          updateProgress();
        }, 100);
      });
      
      // Window resize
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          const wasMobile = config.isMobile;
          config.isMobile = window.innerWidth <= 768;
          config.slidesPerView = config.isMobile ? 1 : 3;
          
          if (wasMobile !== config.isMobile) {
            scrollToSlide(config.currentIndex, false);
          }
        }, 250);
      });
      
      // Start autoplay
      if (config.isAutoplay && config.totalSlides > 1) {
        startAutoplay();
        
        // Pause on hover (desktop only)
        if (!config.isMobile) {
          container.addEventListener('mouseenter', pauseAutoplay);
          container.addEventListener('mouseleave', resumeAutoplay);
        }
      }
    }
    
    function handlePrev() {
      if (config.isAnimating) return;
      
      config.isPaused = true;
      config.currentIndex = (config.currentIndex - 1 + config.totalSlides) % config.totalSlides;
      scrollToSlide(config.currentIndex, true);
      
      setTimeout(() => {
        config.isPaused = false;
      }, 2000);
    }
    
    function handleNext() {
      if (config.isAnimating) return;
      
      config.isPaused = true;
      config.currentIndex = (config.currentIndex + 1) % config.totalSlides;
      scrollToSlide(config.currentIndex, true);
      
      setTimeout(() => {
        config.isPaused = false;
      }, 2000);
    }
    
    function handleTouchStart(e) {
      config.touchStartX = e.touches[0].clientX;
      config.isPaused = true;
    }
    
    function handleTouchMove(e) {
      config.touchEndX = e.touches[0].clientX;
    }
    
    function handleTouchEnd() {
      const swipeDistance = config.touchStartX - config.touchEndX;
      
      if (Math.abs(swipeDistance) > config.minSwipeDistance) {
        if (swipeDistance > 0) {
          // Swiped left - next
          handleNext();
        } else {
          // Swiped right - prev
          handlePrev();
        }
      }
      
      setTimeout(() => {
        config.isPaused = false;
      }, 2000);
    }
    
    function scrollToSlide(index, smooth = true) {
      if (config.isAnimating) return;
      
      config.isAnimating = true;
      
      const slide = slides[index];
      if (!slide) return;
      
      const slideRect = slide.getBoundingClientRect();
      const sliderRect = slider.getBoundingClientRect();
      
      let scrollPosition;
      
      if (config.isMobile) {
        // Mobile: scroll to align slide at left with some padding
        scrollPosition = slider.scrollLeft + slideRect.left - sliderRect.left - 20;
      } else {
        // Desktop: center the middle slide of the visible 3
        const containerCenter = sliderRect.width / 2;
        const slideCenter = slideRect.left - sliderRect.left + slideRect.width / 2;
        scrollPosition = slider.scrollLeft + slideCenter - containerCenter;
      }
      
      slider.scrollTo({
        left: scrollPosition,
        behavior: smooth ? 'smooth' : 'auto'
      });
      
      setTimeout(() => {
        config.isAnimating = false;
        updateProgress();
      }, smooth ? 500 : 0);
    }
    
    function snapToNearestSlide() {
      const sliderRect = slider.getBoundingClientRect();
      const containerCenter = sliderRect.left + sliderRect.width / 2;
      
      let closestSlide = null;
      let closestDistance = Infinity;
      let closestIndex = 0;
      
      slides.forEach((slide, index) => {
        const slideRect = slide.getBoundingClientRect();
        const slideCenter = slideRect.left + slideRect.width / 2;
        const distance = Math.abs(containerCenter - slideCenter);
        
        if (distance < closestDistance) {
          closestDistance = distance;
          closestSlide = slide;
          closestIndex = index;
        }
      });
      
      if (closestSlide) {
        config.currentIndex = closestIndex;
        scrollToSlide(closestIndex, true);
      }
    }
    
    function updateCurrentIndexFromScroll() {
      const sliderRect = slider.getBoundingClientRect();
      const containerCenter = sliderRect.left + sliderRect.width / 2;
      
      let closestIndex = 0;
      let closestDistance = Infinity;
      
      slides.forEach((slide, index) => {
        const slideRect = slide.getBoundingClientRect();
        const slideCenter = slideRect.left + slideRect.width / 2;
        const distance = Math.abs(containerCenter - slideCenter);
        
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });
      
      config.currentIndex = closestIndex;
    }
    
    function updateProgress() {
      // Update current number
      if (currentSpan) {
        const displayNumber = (config.currentIndex + 1).toString().padStart(2, '0');
        currentSpan.textContent = displayNumber;
      }
      
      // Update progress bar
      if (progressBar) {
        const progress = ((config.currentIndex + 1) / config.totalSlides) * 100;
        progressBar.style.width = `${progress}%`;
      }
    }
    
    function startAutoplay() {
      if (!config.isAutoplay || config.totalSlides <= 1) return;
      
      stopAutoplay();
      
      config.autoplayTimer = setInterval(() => {
        if (!config.isPaused && !config.isAnimating) {
          handleNext();
        }
      }, config.autoplayDelay);
    }
    
    function stopAutoplay() {
      if (config.autoplayTimer) {
        clearInterval(config.autoplayTimer);
        config.autoplayTimer = null;
      }
    }
    
    function pauseAutoplay() {
      config.isPaused = true;
    }
    
    function resumeAutoplay() {
      config.isPaused = false;
    }
    
    // Cleanup on page unload
    window.addEventListener('beforeunload', () => {
      stopAutoplay();
    });
  });
});
